import OrderFinal from "../../../Components/Client/OrderFinal";

const OrderFinalPage = () => {
  return <OrderFinal />;
};

export default OrderFinalPage;
